import { render, staticRenderFns } from "./chooseBox.vue?vue&type=template&id=7700ccfa&scoped=true&"
import script from "./chooseBox.vue?vue&type=script&lang=js&"
export * from "./chooseBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7700ccfa",
  null
  
)

export default component.exports